import React, {Component} from 'react';


class LooxStar extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  };

  render() {
    return (
      <React.Fragment>
        {(() => {
          if ( this.props.data>=0.5 ) {
            return (
              <i className="fa fa-star" aria-hidden="true"></i>
            )
          }
          else if ( this.props.data<0.5 && this.props.data>0 ) {
            return (
              <i className="fa fa-star-half-o" aria-hidden="true"></i>
            )
          }
          else{
            return (
              <i className="fa fa-star-o" aria-hidden="true"></i>
            )
          }
        })()}
      </React.Fragment>
    )
  };
}

export default LooxStar;